import { DateTime } from 'luxon';
import { type } from '@mews-framework/utils';
import { ISOFormat } from '../enums';

interface Month {
    value: string;
    timezone: string;
}

function Month(luxon: DateTime): Month {
    return type.create(Month, {
        value: luxon.toFormat(ISOFormat.Month),
        timezone: luxon.zoneName,
    });
}

export default Month;
